import { render, staticRenderFns } from "./updateLog.vue?vue&type=template&id=1cbaa71b&scoped=true"
import script from "./updateLog.vue?vue&type=script&lang=js"
export * from "./updateLog.vue?vue&type=script&lang=js"
import style0 from "./updateLog.vue?vue&type=style&index=0&id=1cbaa71b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbaa71b",
  null
  
)

export default component.exports